import { render } from "./WithdrawalRequest.vue?vue&type=template&id=051c9d7d&scoped=true"
import script from "./WithdrawalRequest.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequest.vue?vue&type=script&lang=js"

import "./WithdrawalRequest.vue?vue&type=style&index=0&id=051c9d7d&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051c9d7d"]])

export default __exports__